import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  Pagination, FinancialItemContainerModel, FinancialItemService,
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-util-select-rounding-item',
  templateUrl: './select-rounding-item.component.html',
  styleUrls: ['./select-rounding-item.component.css']
})

export class SelectRoundingItemComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  private apiVisa = AppConfig.apiVisa;
  @Input() rounding = new FormControl();
  @Output() roundingSelected = new EventEmitter<FinancialItemContainerModel>();
  @Output() roundingChange = new EventEmitter<FormControl>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<FinancialItemContainerModel[]> = new ReplaySubject<FinancialItemContainerModel[]>(1);
  roundingList: FinancialItemContainerModel[] = [];
  selectedRounding: FinancialItemContainerModel;
  filterControl = new FormControl();
  protected _onDestroy = new Subject<void>();

  constructor(
    private fiService: FinancialItemService
  ) {
  }

  ngOnInit() {
    const paging = new Pagination();
    paging.conditionalCriteria.push({
      columnName: 'txn_type',
      operator: '=',
      value: "DOC_HEADER_ADJUSTMENT",
    });


    this.subs.sink = this.fiService.getByCriteria(paging,this.apiVisa).subscribe(
      {next: resolve => {
        console.log()
        this.roundingList = resolve.data;
        if(resolve.data && resolve.data.length===1){
          this.onSelect(resolve.data[0].bl_fi_mst_item_hdr.guid.toString());
        }
        this.filteredOptions$.next(this.roundingList);
      }});
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterRounding(resolve)});
  }



  filterRounding(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.roundingList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.roundingList.filter(c =>
        c.bl_fi_mst_item_hdr.code.toLowerCase().indexOf(search) > -1 ||
        c.bl_fi_mst_item_hdr.name.toLocaleLowerCase().includes(search)
      );
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(guid: string) {
    if (guid) {
      this.rounding.patchValue(guid);
      this.selectedRounding = this.roundingList.find(n => n.bl_fi_mst_item_hdr.guid === guid);
      this.roundingSelected.emit(this.selectedRounding);

    }
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
